import PageTabs from "@/components/PageTabs/PageTabs";
import { useNavigate } from "react-router-dom";
import styles from "./ProductDetail.module.scss";
import useProductDetailTabs from "./useProductDetailTabs";

export default function ProductDetailTabs({ productId }: { productId: number }) {
  const navigate = useNavigate();

  const { tabs, activeTab } = useProductDetailTabs({ productId });

  const onChange = (key: string) => {
    navigate(
      {
        pathname: `/products/${productId}/${key}`,
      },
      { replace: true }
    );
  };

  return (
    <PageTabs
      noLine={true}
      activeKey={activeTab}
      items={tabs}
      onChange={onChange}
      className={styles.pagetabs}
    />
  );
}
